<template>
  <div>
    <v-simple-table class="table-layout pa-5 pb-0 border-table">
      <template v-slot:default>
        <thead>
        <tr>
          <th class="th-custom header-table-sticky" rowspan="2" colspan="1">Nhân viên</th>
          <th class="th-custom header-table-sticky" colspan="2">Giao hàng thành công</th>
          <th class="th-custom header-table-sticky" colspan="2">Chưa giao hàng</th>
          <th class="th-custom header-table-sticky" colspan="2">Đơn hoàn</th>
        </tr>
        <tr>
          <th class="th-custom-2 header-table-sticky-ratio">Total</th>
          <th class="th-custom-2 header-table-sticky-ratio">Tỷ lệ</th>
          <th class="th-custom-2 header-table-sticky-ratio">Total</th>
          <th class="th-custom-2 header-table-sticky-ratio">Tỷ lệ</th>
          <th class="th-custom-2 header-table-sticky-ratio">Total</th>
          <th class="th-custom-2 header-table-sticky-ratio">Tỷ lệ</th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="!_.isEmpty(dataTable.dataDelivery)">
          <td class="total-text font-weight-bold">Tất cả</td>
          <td class="total-text font-weight-bold">{{ dataTable.dataDelivery['Giao thành công'] }}</td>
          <td class="total-text font-weight-bold" :class="computePercent(dataTable.dataDelivery['Giao thành công'], dataTable.total) > 77 ? 'blue-text' : 'red-text'">
            {{ computePercent(dataTable.dataDelivery['Giao thành công'], dataTable.total) }} %
          </td>
          <td class="total-text font-weight-bold">{{ dataTable.dataDelivery['Đang giao hàng'] }}</td>
          <td class="total-text font-weight-bold">{{ computePercent(dataTable.dataDelivery['Đang giao hàng'], dataTable.total) }} %</td>
          <td class="total-text font-weight-bold">{{ dataTable.dataDelivery['Hoàn'] }}</td>
          <td class="total-text font-weight-bold" :class="computePercent(dataTable.dataDelivery['Hoàn'], dataTable.total) < 23 ? 'blue-text' : 'red-text'">
            {{ computePercent(dataTable.dataDelivery['Hoàn'], dataTable.total) }} %
          </td>
        </tr>
        <template v-if="data.length">
          <tr v-for="item in data">
          <td class="total-text">{{item.name}}</td>
          <td class="total-text">{{ item.dataDelivery['Giao thành công'] }}</td>
          <td class="total-text" :class="computePercent(item.dataDelivery['Giao thành công'], item.total) > 77 ? 'blue-text' : 'red-text'">
            {{ computePercent(item.dataDelivery['Giao thành công'], item.total) }} %
          </td>
          <td class="total-text">{{ item.dataDelivery['Đang giao hàng'] }}</td>
          <td class="total-text">{{ computePercent(item.dataDelivery['Đang giao hàng'], item.total) }} %</td>
          <td class="total-text">{{ item.dataDelivery['Hoàn'] }}</td>
          <td class="total-text" :class="computePercent(item.dataDelivery['Hoàn'], item.total) < 23 ? 'blue-text' : 'red-text'">
            {{ computePercent(item.dataDelivery['Hoàn'], item.total) }} %
          </td>
          </tr>
        </template>
        </tbody>
        <!-- <common-no-result
          v-if="!employeeReports.length"
        /> -->
      </template>
    </v-simple-table>

  </div>
</template>
<script>

import { formatPrice } from '@/helpers/utils'
export default {
  components: {},
  props: {
    data: {
      type: Array,
      default: () => ([])
    },
    dataTable: {
      default: () => ({})
    },
  },
  data () {
    return {
      errorMessage: '',
    }
  },
  created () {
  },
  computed: {

  },
  methods: {
    averageCallDuration(totalDurationSuccess, totalCallSuccess) {
      if (totalCallSuccess == 0 || totalDurationSuccess == 0) {
        return 0
      } else {
        return +((totalDurationSuccess / totalCallSuccess) / 60).toFixed(2)
      }
    },
    computePercent(val1, val2) {
      if(val2) {
        return ((val1/val2)*100).toFixed(0);
      }
      return 0;
    }
  },
}
</script>
<style scoped>
.th-custom {
  background-color: green;
  color: #d2f1f0 !important;
}
.th-custom-2 {
  background-color: #D2F1F0;
}
.blue-text {
  color: green;
}
.red-text {
  color: red;
}
.v-data-table td {
  font-size: 17px;
}
.table-layout tbody tr {
   height: 50px;
}
.border-div {
  border-left: 2px solid black;
}
/deep/.v-data-table__wrapper {
  max-height: 500px;
  overflow-y: scroll;
}
.header-table-sticky {
  position: sticky;
  top: 0px;
}
.header-table-sticky-ratio {
  position: sticky;
  top: 48px;
}
</style>